import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { jsonp } from '@ifeng-fe/ui_base';
import { ChipMap } from '../chipMap';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';
import Part from './Part';
import SmallBanner from '@src/pc/index/layout/components/SmallBanner';
import SlideSwiper from '@src/pc/index/layout/SlideSwiper';
import GridList from '@src/pc/index/layout/components/GridList';
import Footer from '@src/common/Footer';
import Nav from '@src/pc/awards/layout/Nav';

const Layout = ({ content }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [dataList, setDataList] = useState({});
    const [isOk, setIsOk] = useState(false);

    const fetchData = async () => {
        const data = await jsonp('https://shankapi.ifeng.com/feedflow/coopdoc/strapi_1ecde77bd82b4fac2afd8aeadd29de27_china_honor/info/cb', {
            jsonpCallback: 'cb',
            cache: false,
        });

        if (data.code === 0) {
            setDataList(data.data.result);
        }
        setIsOk(true);
    };

    useEffect(() => {
        fetchData();
    }, []);

    const onChangeActiveIndex = (e) => {
        const { index } = e.currentTarget.dataset;

        setActiveIndex(+index);
    };

    const isEmpty = () => {
        return !!((!dataList.gold || (dataList.gold && dataList.gold.length === 0)) &&
            (!dataList.silver || (dataList.silver && dataList.silver.length === 0)) &&
            (!dataList.copper || (dataList.copper && dataList.copper.length === 0)) &&
            (!dataList.break || (dataList.break && dataList.break.length === 0)));
    };

    return (
        <div className={styles.layout}>
            <Nav width={1200} />
            <div className={styles.mainImage}>
                <img className={styles.banner} src="https://x0.ifengimg.com/ucms/2022_03/EF60CB8774A003684A870013042261611088DE5B_size613_w5120_h1000.jpg" alt="奖牌榜" />
                <img className={styles.logo} src="https://x0.ifengimg.com/ucms/2022_03/B47C1EF290E8847AEBCC42BF8E147797252E468F_size29_w578_h40.png" alt="logo" />
            </div>
            <div className={styles.main}>
                <div className={styles.left}>
                    {
                        isOk &&
                        (isEmpty()
                            ?
                                <div className={styles.emptyWp}>
                                    <img src="https://x0.ifengimg.com/ucms/2022_04/0FDBCC30B8E791779DF20D9740A94BEC22CB5DA8_size12_w224_h224.png" alt="empty" />
                                    <a href="https://sports.ifeng.com/loc/special/beijing2022" target="_blank" rel="noreferrer">去看看最新冬奥资讯吧~</a>
                                </div>
                            :
                                <>
                                    {
                                        dataList.gold && <Part type="gold" list={dataList.gold} />
                                    }
                                    {
                                        dataList.silver && <Part type="silver" list={dataList.silver} />
                                    }
                                    {
                                        dataList.copper && <Part type="copper" list={dataList.copper} />
                                    }
                                    {
                                        dataList.break && <Part type="break" list={dataList.break} />
                                    }
                                </>)
                    }
                </div>
                <div className={styles.right}>
                    <div className={styles.slide}>
                        <Chip key="SmallBanner3" {...ChipMap.SmallBanner3} content={content['SmallBanner3']}>
                            <SmallBanner />
                        </Chip>
                        <SlideSwiper />
                        <div className={styles.switch}>
                            <span className={activeIndex === 0 ? styles.active : ''} data-index={0} onClick={onChangeActiveIndex}>中国明星</span>
                            <span className={activeIndex === 1 ? styles.active : ''} data-index={1} onClick={onChangeActiveIndex}>世界明星</span>
                        </div>
                        <Chip key="Stars" {...ChipMap.Stars} content={content['Stars']}>
                            <GridList navIndex={activeIndex} />
                        </Chip>
                        <Chip key="SmallBanner4" {...ChipMap.SmallBanner4} content={content['SmallBanner4']}>
                            <SmallBanner />
                        </Chip>
                        <Chip key="PlaceList" {...ChipMap.PlaceList} content={content['PlaceList']}>
                            <GridList />
                        </Chip>
                    </div>
                </div>
            </div>
            <div className={styles.footerBanner}>
                <img src="https://x0.ifengimg.com/ucms/2022_03/3343D2D79A1ACEB6AAC96C09E1101D8F43A3DFD3_size536_w5120_h280.png" alt="" />
            </div>
            <div className={styles.footer}>
                <Footer data={content.footer} />
            </div>
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object
};

export default errorBoundary(Layout);
